import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";

const MenuData = () => {
    // const history = useHistory();
    //state data
    const [isEmployeeManagement, setIsEmployeeManagement] = useState(false);
    const [isDataSetting, setIsDataSetting] = useState(false);
    const [isAdminSetting, setIsAdminSetting] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('010001');

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== '010001') {
            setIsEmployeeManagement(false);
        }
        if (iscurrentState !== '020000') {
            setIsDataSetting(false);
        }
        if (iscurrentState !== '030000') {
            setIsAdminSetting(false);
        }
    }, [
        iscurrentState,
        isEmployeeManagement,
        isDataSetting,
        isAdminSetting
    ]);

    const menuItems = [
        {
            id: "010001",
            label: "Employee Management",
            icon: "ri-team-line",
            link: "/employee",
            groupPage: "",
            click: function (e) {
                e.preventDefault();
                setIsEmployeeManagement(!isEmployeeManagement);
                setIscurrentState('010001');
            },
            stateVariables: isEmployeeManagement,
        },
        {
            id: "020000",
            label: "Data Setting",
            icon: "ri-file-list-3-line",
            link: "/#",
            groupPage: "",
            click: function (e) {
                e.preventDefault();
                setIsDataSetting(!isDataSetting);
                setIscurrentState('020000');
            },
            stateVariables: isDataSetting,
            subItems: [
                {
                    id: "020101",
                    label: "Company structure",
                    link: "/business-unit",
                    parentId: "020000",
                    groupPage: "business-unit,department,sub-department,division,sub-division,section,sub-section",
                },
                {
                    id: "020001",
                    label: "Position",
                    link: "/position",
                    parentId: "020000",
                    groupPage: "position,level-position",
                },
                {
                    id: "020201",
                    label: "Education",
                    link: "/level-education",
                    parentId: "020000",
                    groupPage: "level-education,institution",
                },
                {
                    id: "020005",
                    label: "Type of employment",
                    link: "/employment-type",
                    parentId: "020000",
                    groupPage: "",
                },
                {
                    id: "020003",
                    label: "Cost center",
                    link: "/cost-center",
                    parentId: "020000",
                    groupPage: "",
                },
            ]
        },
        {
            id: "030000",
            label: "Admin Setting",
            icon: "ri-settings-3-line",
            link: "/#",
            groupPage: "",
            click: function (e) {
                e.preventDefault();
                setIsAdminSetting(!isAdminSetting);
                setIscurrentState('030000');
            },
            stateVariables: isAdminSetting,
            subItems: [
                {
                    id: "030001",
                    label: "User",
                    link: "/user",
                    parentId: "030000",
                    groupPage: "",
                },
            ]
        }
    ];

    return (
        <React.Fragment>
            {menuItems}
        </React.Fragment>
    );
};
export default MenuData;